import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';
import { useFetchOnboardingReverseTrial } from '../use-fetch-onboarding-reverse-trial/index.tsx';

/**
 * This hook is used to check if the user is signed up in a reverse trial
 * and also user is within the attribution window
 * which identify the user is currently in the 'first' reverse trial
 */
const ATTRIBUTION_WINDOW = 45; // days
export const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

export const useInReverseTrial = () => {
	const firstActivationDate = useFirstActivationDateMs();
	const { premiumTrialOnSignup, isReady } = useFetchOnboardingReverseTrial();

	if (isReady) {
		return {
			isInReverseTrial:
				premiumTrialOnSignup &&
				!!firstActivationDate &&
				Date.now() - firstActivationDate <= ATTRIBUTION_WINDOW * MILLISECONDS_IN_DAY,
			isReady,
		};
	}

	return {
		isInReverseTrial: undefined,
		isReady,
	};
};
